import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initCourseFunction() {  
    let courseSwiper;
    (function () {
        
        courseSwiper = new Swiper(".js-courseSlider", {
            // allowTouchMove: false,
            spaceBetween: 30,
            slidesPerView: 1.145,
            observer: true,
            resizeObserver: true,
            observeParents: true,
            
            navigation: {
                nextEl: '.courseSliderNav__btn--next',
                prevEl: '.courseSliderNav__btn--prev',
            },
            breakpoints: {
                550: {
                    slidesPerView: 2,
                },
                769: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
        });
    })();

    (function () {
        
        const swiper = new Swiper(".js-lessonSlider", {
            // allowTouchMove: false,
            spaceBetween: 30,
            slidesPerView: 1,
            observer: true,
            resizeObserver: true,
            observeParents: true,
            pagination: {
                el: '.lessonSlider__pagination',
                clickable: true, 
            },
            
            breakpoints: {
                550: {
                    slidesPerView: 2,
                },
                769: {
                    slidesPerView: 2,
                },

                1000: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 2.9,
                },

            },
        });
    })();

    (function () {
        const $modal = $('.employeeModal');
        if (!$modal.length) return; // exit if modal not present
        const $modalCloseBtn = $modal.find('.employeeModal__content__closeBtn');
        const $modalPrev = $modal.find('.employeeModal__nav--prev');
        const $modalNext = $modal.find('.employeeModal__nav--next');

        function updateNavButtons(index) {
            const total = $('.courseSlider__item').length;
            $modalPrev.prop('disabled', index === 0);
            $modalNext.prop('disabled', index === total - 1);
        }

        function populateModal(index) {
            const $slide = $('.courseSlider__item').eq(index);
            if (!$slide.length) return;
            const titleEn = $slide.find('.title__en').html() || '';
            const titleJa = $slide.find('.title__ja').html() || '';
            const desc = $slide.find('.courseSlider__item__description').html() || '';
            const img = $slide.find('.courseSlider__item__img img').attr('src') || '';
            $modal.find('.title__en').html(titleEn);
            $modal.find('.title__ja').html(titleJa);
            $modal.find('.modText').html(desc);
            $modal.find('.employeeModal__content__img img').attr('src', img);
            $modal.data('currentIndex', index);
            updateNavButtons(index);
        }

        function openModal(index) {
            populateModal(index);
            $modal.addClass('is-open');
        }

        function closeModal() {
            $modal.removeClass('is-open');
        }

        // Click on slide items
        $('.courseSlider__item').each(function(idx) {
            $(this).on('click', function() {
                openModal(idx);
                // sync main swiper
                courseSwiper.slideTo(idx);
            });
        });

        $modalPrev.on('click', function(e) {
            e.stopPropagation();
            let idx = $modal.data('currentIndex');
            if (idx > 0) {
                idx = idx - 1;
                openModal(idx);
                courseSwiper.slideTo(idx);
            }
        });

        $modalNext.on('click', function(e) {
            e.stopPropagation();
            let idx = $modal.data('currentIndex');
            const total = $('.courseSlider__item').length;
            if (idx < total - 1) {
                idx = idx + 1;
                openModal(idx);
                courseSwiper.slideTo(idx);
            }
        });

        $modalCloseBtn.on('click', closeModal);
        
        $modal.on('click', function(e) {
            if (!$(e.target).closest('.employeeModal__nav, .employeeModal__content').length) {
                closeModal();
            }
        });
    })();

    (function(){
        let curriculumAccordion = $(".js-curriculumAccordion");
        let curriculumAccordionTrigger = curriculumAccordion.find(".curriculumAccordion__item__header");

        curriculumAccordionTrigger.on("click", function(){
            $(this).toggleClass("is-active");
            $(this).next().slideToggle();
        })
    })();
}